import Fetch from './fetch';

const NotificationsApi = {
  markClicked: (id, successCb, errorCb) => Fetch.postV2(`notifications/${id}/mark_clicked`, {}, successCb, errorCb),
  getNotificationCount: (id, successCb, errorCb) =>
    Fetch.get(`users/${id}/notifications/count`, {}, successCb, errorCb),
  markAllNotificationsRead: (id, successCb, errorCb) =>
    Fetch.postV2(`users/${id}/notifications/read`, {}, successCb, errorCb),
  loadNotifications: ({ id, offset }, successCb, errorCb) =>
    Fetch.get(`users/${id}/notifications?offset=${offset}`, {}, successCb, errorCb),
};

export default NotificationsApi;
